import apiClient from '@/axios';

// Получить все уведомления
export const fetchNotifications = async () => {
  try {
    const response = await apiClient.get('/admin/get/notifications');
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении уведомлений:', error);
    throw error;
  }
};

// Удалить уведомление
export const deleteNotification = async (id) => {
  try {
    await apiClient.delete(`/admin/delete/notifications/${id}`);
    return id;
  } catch (error) {
    console.error('Ошибка при удалении уведомления:', error);
    throw error;
  }
};




export const createNotification = async (data) => {
    try {
      const response = await apiClient.post('/admin/create/notifications', data);
      return response.data;
    } catch (error) {
      console.error('Ошибка при создании уведомления:', error);
      throw error;
    }
  };